import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; 

import {
  productsList,
  resetProductList,
  getTaxgsts,
  CreateProduct,
} from "../../reducers/commonReducer";
import { getCategoriesFrontEnd } from "../../reducers/frontEndReducer";
import SideMenu from "../../Components/SideMenu";

const schema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().required("Description is required."),
  mrp: yup.string().required("MRP is required."),
  sale: yup.string(),
  timePeriod: yup.string().required("Time period is required."),
  service: yup.object().required("Select at least one service."),
  tax_class: yup.string().required("Tax Class is required."),
  status: yup.bool().required("Status is required."),
  benefits: yup
    .array()
    .of(yup.string().required("Benefit is required."))
    .min(1, "At least one benefit is required."),
});

const generateSlug = (text) => text?.toLowerCase().replace(/\s+/g, "-");

function AddProduct() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  useEffect(() => {
    dispatch(getTaxgsts());
    dispatch(getCategoriesFrontEnd());
  }, [dispatch]);

  const { getTaxgstsData } = useSelector((state) => state.commonReducer);
  const { getCatsFrontEndData } = useSelector((state) => state.frontEndReducer);

  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <Row className="mb-3 products-design">
          <Formik
            validationSchema={schema}
            initialValues={{
              name: "",
              description: "",
              mrp: "",
              sale: "",
              timePeriod: "",
           
              tax_class: "63b53729a403053ba0d99d99",
              status: true,
              benefits: [""],
            }}
            onSubmit={async (values, { resetForm }) => {
              const finalValues = {
                ...values,
                slug: generateSlug(values.name),
                category: values.service?.value,
              };
              delete finalValues.service;

              const res = await dispatch(CreateProduct(finalValues));
              if (res?.status === "1") {
                resetForm();
                await dispatch(resetProductList());
                await dispatch(productsList());
            
              }
            }}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              setFieldValue,
              errors,
              touched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={values.name}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("slug", generateSlug(e.target.value));
                        }}
                        isInvalid={!!errors.name && touched.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group>
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        isInvalid={!!errors.description && touched.description}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.description}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>MRP</Form.Label>
                      <Form.Control
                        type="number"
                        name="mrp"
                        value={values.mrp}
                        onChange={handleChange}
                        isInvalid={!!errors.mrp && touched.mrp}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mrp}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Sale</Form.Label>
                      <Form.Control
                        type="number"
                        name="sale"
                        value={values.sale}
                        onChange={handleChange}
                        isInvalid={!!errors.sale && touched.sale}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sale}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <Form.Label>Service</Form.Label>
                    <Select
                      name="service"
                      options={getCatsFrontEndData?.map((data) => ({
                        value: data?.id,
                        label: data?.name,
                      }))}
                      onChange={(option) => setFieldValue("service", option)}
                      value={values.service}
                      className={
                        errors.service && touched.service ? "is-invalid" : ""
                      }
                      placeholder="Select Service"
                    />
                    <div className="invalid-feedback d-block">
                      {errors.service?.label || errors.service}
                    </div>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Tax Class</Form.Label>
                      <Form.Control
                        as="select"
                        name="tax_class"
                        value={values.tax_class}
                        onChange={handleChange}
                        isInvalid={!!errors.tax_class && touched.tax_class}
                      >
                        {getTaxgstsData?.list?.map((data) => (
                          <option value={data?.id} key={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.tax_class}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                
                    <Col md={5}>
                                      <Form.Group>
                                        <Form.Label>Time Period (Days)</Form.Label>
                                        <Form.Control
                                          type="number"
                                          name="timePeriod"
                                          value={values.timePeriod}
                                          onChange={handleChange}
                                          isInvalid={!!errors.timePeriod}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {errors.timePeriod}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </Col>
                </Row>

                <FieldArray name="benefits">
                  {({ push, remove }) => (
                    <>
                      {values.benefits.map((benefit, index) => (
                        <Row key={index}>
                          <Col md={11}>
                            <Form.Group>
                              <Form.Label>Benefit - {index + 1}</Form.Label>
                              <Form.Control
                                type="text"
                                name={`benefits[${index}]`}
                                value={benefit}
                                onChange={handleChange}
                                isInvalid={
                                  errors.benefits &&
                                  errors.benefits[index] &&
                                  touched.benefits?.[index]
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.benefits?.[index]}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="d-flex align-items-end">
                            {index > 0 && (
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => remove(index)}
                              >
                                Remove
                              </Button>
                            )}
                          </Col>
                        </Row>
                      ))}
                      <Row>
                        <Col>
                          <Button
                            variant="primary"
                            className="mt-3"
                            onClick={() => push("")}
                          >
                            Add Benefit
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </FieldArray>

                <Row className="mt-4">
                  <Col>
                    <Button variant="success" type="submit">
                      Add Plans
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Row>
      </div>
    </>
  );
}

export default AddProduct;
